import actions from './actions';

const {
	
	FETCH_QR_BEGIN,
	FETCH_QR_SUCCESS,
	FETCH_QR_ERR,

} = actions;

const initialStateFilter = {
	data: null,
	loading: false,
	error: null,
};

const kbankReducer = (state = initialStateFilter, action) => {
	const { type, data, err } = action;
	switch (type) {
		case FETCH_QR_BEGIN:
			return {
				data: null,
				loading: true,
				error: null,
			};
		case FETCH_QR_SUCCESS:
			return {
				data: data,
				loading: false,
				error: null,
			};
		case FETCH_QR_ERR:
			return {
				data: null,
				loading: false,
				error: err,
			};

		default:
			return state;
	}
};

export default kbankReducer;
